import { InstructorHeader } from '../header'
import Footer from '../../footer'
import { useNavigate, useParams } from 'react-router-dom'
import StudentInfoBox from '../studentinfo/studentinfobox'

import CheklistForProfile from '../../instructor/studentGrid/profile2sublists/checklistforprofile'
import MainEssayForProfile from '../../instructor/studentGrid/profile2sublists/mainessayforprofile'
import SuplementalEssayForProfile from '../../instructor/studentGrid/profile2sublists/suplementalessayforprofile'
import AditionalEssayForProfile from '../../instructor/studentGrid/profile2sublists/additionalinfoforprofile'
import SeniorBragSheetForProfile from '../../instructor/studentGrid/profile2sublists/seniorbragsheetforprofile'
import Activities from '../../instructor/studentGrid/sublist/activities'

import { useRef,useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { logopcp } from '../../imagepath'
import InstructorSidebar from '../sidebar'
import style from "./studentprofile_2.module.css"
import StudentInfoPdf from '../../instructor/studentGrid/studentInfoPdf'

const ParentStudentProfile_2 = () => {
  const [mobileMenu, setMobileMenu] = useState(false)
  const navigate = useNavigate()
  let { slug } = useParams()

  const componentRef = useRef()
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current
  // })
   const handlePrint = useReactToPrint({
     content: () => {
       removeBorderClasses()
       return componentRef.current
     },
     onAfterPrint: () => {
       restoreBorderClasses()
     }
   })

   const removeBorderClasses = () => {
    const elements = document.querySelectorAll('.border.border-3.border-primary');
    const transcriptDiv = document.getElementById('transcript_div_pdf');
    const pdfLogo = document.getElementById('pdf_logo');
    const studentInfoBox = document.getElementById("student-info-box");
    const studentInfoPdf = document.getElementById("studentInfoPdf");
    
    if (transcriptDiv) {
      transcriptDiv.classList.add('pdf_transcript_div');
      transcriptDiv.classList.remove('transcript_div');
    }
  
    if (pdfLogo) {
      pdfLogo.style.display = 'block';
    }
    studentInfoBox.style.display = "none";
    studentInfoPdf.style.display = "block";
    elements.forEach((element) => {
      element.classList.add('border-hidden');
      element.classList.remove('border', 'border-3', 'border-primary');
    });
  }
  
  const restoreBorderClasses = () => {
    const elements = document.querySelectorAll('.border-hidden');
    const transcriptDiv = document.getElementById('transcript_div_pdf');
    const pdfLogo = document.getElementById('pdf_logo');
    
    if (transcriptDiv) {
      transcriptDiv.classList.remove('pdf_transcript_div');
      transcriptDiv.classList.add('transcript_div');
    }
  
    if (pdfLogo) {
      pdfLogo.style.display = 'none';
    }
  
    elements.forEach((element) => {
      element.classList.add('border', 'border-3', 'border-primary');
      element.classList.remove('border-hidden');
    });
  }
  

  return (
    <>
      <div className='main-wrapper'>
        {/* <AdminHeader activeMenu={""}/> */}
        {/* <InstructorHeader
          activeMenu={'Dashboard'}
          setMobileMenu={setMobileMenu}
          mobileMenu={mobileMenu}
        /> */}

        <section className='course-content'>
          {/* <InstructorSidebar
            activeMenu={'Dashboard'}
            setMobileMenu={setMobileMenu}
            mobileMenu={mobileMenu}
          /> */}
          <div className='container-fluid w-80'>
            <div className='d-flex justify-content-between align-items-center'>
              <div className=''>
                <button
                  onClick={() => navigate(-1)}
                  className='btn btn-black btn-sm mb-2'
                >
                  {'<< Back'}
                </button>
              </div>
              <div className='widget-btn'>
                <button
                  onClick={handlePrint}
                  className='btn btn-info-light next_btn'
                >
                  Print Page
                </button>
              </div>
            </div>
            <div className='card wish-card' ref={componentRef}>
              <div className='card-header'>
                <div id="student-info-box">
                  <StudentInfoBox slug={slug} taskshow={false} />
                </div>
                <img
                  src={logopcp}
                  className={`${style.pdfLogo} img-fluid pdf_logo`}
                  id='pdf_logo'
                  alt='Logo'
                  style={{ display: 'none' }}
                />
                  <div id="studentInfoPdf" style={{ display: "none" }}>
                <StudentInfoPdf slug={slug}/>
                </div>
              </div>
              <div className='page-break'>
                <CheklistForProfile slug={slug} parent={true} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <MainEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <SuplementalEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <Activities slug={slug} show={false} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <AditionalEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <SeniorBragSheetForProfile slug={slug} />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  )
}

export default ParentStudentProfile_2
